import { createSlice } from '@reduxjs/toolkit';
import { dailyRateOperation } from './dailyOperation';

export const dailySlice = createSlice({
  name: 'daily',
  initialState: {},
  extraReducers: b => {
    b.addCase(dailyRateOperation.fulfilled, (state, { payload }) => {
      if (payload.error) {
        state.error = payload.error.message;
      } else {
        return (state = payload);
      }
    }).addCase(dailyRateOperation.rejected, (state, { payload }) => {
      return (state = {});
    });
  },
});
